import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import ReactFlagsSelect from "react-flags-select";
import KycShell, { BrowserOnlyWarning } from '../components/KycShell';

const Home = () => {
  const [countrystate, setCountry] = useState("");
  const brandname = localStorage.getItem('brandname');
  const brandlogo = localStorage.getItem('brandlogo');
  const [value, setValue] = useState(null);
  const [selected, setSelected] = useState("");
  const [disabledbtn, setDisabled] = useState(false);
  const [btn, setBtn] = useState("btn btn-primary");
  const [btntxt, setBtnTxt] = useState("Continue");
  const [btnicon, setBtnIcon] = useState("fa-solid fa-arrow-right");
  const [isMobile, setIsMobile] = useState(false);

  const navigate = useNavigate();


  const checkIfMobile = () => {
    if (window.innerWidth <= 768) {
      return true;
    }
    return false;
  };
  const updateMedia = () => {
    setIsMobile(checkIfMobile());
  };
  useEffect(() => {
    updateMedia();
    window.addEventListener('resize', updateMedia);
    return () => {
      window.removeEventListener('resize', updateMedia);
    };
  }, []);
  const getData = async () => {
    try {
      const res = await axios.get("https://api.ipify.org/?format=json");
      localStorage.setItem('Ip-Adrees', res.data.ip);
    } catch (error) {
      console.error("Error fetching IP address:", error);
    }
  };
  useEffect(() => {
    if (selected !== '') {
      localStorage.setItem('Selected-country', selected);
    }
  }, [selected]);

  const nextpage = async () => {
    setBtnTxt("");
    setDisabled(true);
    setBtn("btn btn-success");
    setBtnIcon("fa-solid fa-check");

    const uuid = localStorage.getItem('uuid');
    const country = localStorage.getItem('Selected-country');

    let data = JSON.stringify({
      "uuid": uuid,
      "country": country,
    });

    let config = {
      method: 'POST',
      mode: 'cors',
      url: 'https://kyc2.codegotech.com/check_api_idproof',
      headers: {
        'Content-Type': 'application/json',
      },
      data: data
    };

    try {
      const response = await axios.request(config);
      if (response.status === 200) {
        if (response.data.status === 1) {
          localStorage.setItem('setapicountryname', response.data.countryname);
          localStorage.setItem('setapipassport', 1);
          localStorage.setItem('setidcard', response.data.idcard);
          localStorage.setItem('setdriverlicense', response.data.driver_license);
          localStorage.setItem('setpermitresidence', 0);
          localStorage.setItem('passport_type', 0);
          localStorage.setItem('idcard_type', response.data.idcard_type);
          localStorage.setItem('driver_license_type', response.data.driver_license_type);
          localStorage.setItem('permit_residence_type', 0);
          navigate('/idprooftype');
        } else {
          navigate('/Passport');
        }
      }
    } catch (error) {
      console.error("Error during API request:", error);
    }
  };
  useEffect(() => {
    let uuids = localStorage.getItem('uuid');
    if (uuids === null) {
      navigate('/');
    }
  }, [navigate]);


  useEffect(() => {

  }, [isMobile]);

  return (
    <>
      {!isMobile && <BrowserOnlyWarning />}

      {isMobile && (
        <KycShell step={2} brandName={brandname}>
          <div className="kyc-card">
            <div className="kyc-card__eyebrow">Identity document</div>
            <h1 className="kyc-card__title">Where was your document issued?</h1>
            <p className="kyc-card__subtitle">
              Select the country that issued your identity document. We will adapt
              the allowed document types accordingly.
            </p>

            <div className="kyc-field">
              <label className="kyc-label">Issuing country</label>
              <ReactFlagsSelect
                value={value}
                searchable
                selected={selected}
                flush={true}
                onSelect={(code) => setSelected(code)}
              />
            </div>

            {selected && (
              <button
                className="btn_continue"
                disabled={disabledbtn}
                onClick={nextpage}
                style={{ width: '100%', marginTop: 4 }}
              >
                {btntxt || 'Continue'}
                <i className={btnicon} style={{ marginLeft: 8 }}></i>
              </button>
            )}
          </div>
        </KycShell>
      )}
    </>
  );
};

export default Home;
